import styled from 'styled-components';

export const Container = styled.div`
  width: 100vw;
  height: auto;
  min-height: 100vh; /* Garante altura mínima de uma página */
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  page-break-inside: avoid;

  @media print {
    & {
      display: flex;
      margin: 0;
      padding: 0;
      height: auto;
      min-height: 250mm; /* Altura mínima para impressão (A4) */
      max-height: 280mm; /* Evita que passe para segunda página */
      page-break-inside: avoid;
    }
  }
`;

export const Ticket = styled.table`
  border-collapse: collapse;
  width: 710px;
  page-break-inside: avoid;

  td {
    border: 1px solid #000;
  }

  .logo {
    width: 112.5px;
    height: 80px;

    display: flex;
    justify-content: center;

    img {
      width: 80px;
      height: 80px;
    }
  }

  .protocol {
    width: 350px;
  }

  .number {
    width: 118px;
  }
`;

export const Td = styled.td`
  height: 40px;

  div {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    height: 100%;
    width: 100%;
    margin: 0px;
    padding: 0px;

    span {
      font-size: 11px;
      margin-left: 8px;
      margin-right: 0px;
      align-self: flex-start;
    }

    strong {
      font-size: 13px;
      align-self: center;
      margin-bottom: 3px;
    }
  }

  .header {
    width: 600px;
    justify-content: center;

    strong {
      font-size: 16px;
    }
  }

  .client,
  .cod {
    width: 300px;
  }

  .user {
    width: 70%;
    padding-left: 8px;
  }

  .barcode {
    height: 120px;
    width: 120px;
    padding: 5px;

    strong {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;

      img,
      svg {
        max-width: 80px !important;
        max-height: 80px !important;
        width: 80px !important;
        height: 80px !important;
        display: block;
        margin: 0;
      }
    }
  }

  .qrcode {
    height: 120px;
    width: 120px;
    padding: 5px;

    strong {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;

      img,
      svg {
        max-width: 80px !important;
        max-height: 80px !important;
        width: 80px !important;
        height: 80px !important;
        display: block;
        margin: 0;
      }
    }
  }
`;

export const TdTable = styled.div`
  width: 100%;
  height: auto;
  min-height: 180mm; /* Altura mínima para ocupar quase uma página completa */
  max-height: 250mm; /* Altura máxima para evitar segunda página */
  overflow: visible;
  page-break-inside: avoid;
  display: flex;
  flex-direction: column;

  padding: 10px;
  table {
    border: 0;
    border-spacing: 0px;
    page-break-inside: avoid;
    table-layout: fixed;
    flex: 1;

    tbody {
      min-height: 120mm; /* Altura mínima reduzida para o tbody */
      vertical-align: top;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
    }

    tr {
      height: 20px; /* Fixed height for table rows */
      display: table;
      width: 100%;
      table-layout: fixed;
    }

    th {
      font-size: 11px;
      border-bottom: 1px solid #000;
      padding: 2px 4px;
    }

    td {
      border: 0;
      font-size: 11px;
      padding: 2px 4px;
      vertical-align: top;
    }

    .obs {
      border-bottom: 1px solid #777;
    }

    .document {
      text-align: left;
      width: 525px;
    }

    .comp {
      text-align: center;
      width: 97px;
    }
  }

  > span {
    font-size: 10px;
    overflow: visible;
    display: block;
    flex-shrink: 0;
  }
`;

export const CompanyInfo = styled.div`
  width: 100%;
  height: 15px;
  font-size: 11px;
  text-align: center;
  margin-top: 5px;
  page-break-before: avoid;

  strong,
  span {
    margin: 5px;
  }
`;
